export default __webpack_public_path__ + "static/media/verify-email-sent.7b274c4d.png";